import { NotificationsActions, NotificationsActionTypes } from "./actionTypes";
import { INotificationsState } from "./store";


const initialState: INotificationsState = {
  notification: {
    message: undefined,
    severity: undefined
  }
};

export function notificationsReducer(
  state = initialState,
  action: NotificationsActions
): INotificationsState {
  switch (action.type) {
    case NotificationsActionTypes.ADD_NOTIFICATION_MESSAGE:
      return {
        ...state,
        notification: action.notification,
      };
    case NotificationsActionTypes.CLEAR_NOTIFICATION_MESSAGE:
      return {
        ...state,
        notification: undefined,
      };
  }
  return state;
}
